import React from 'react';
import { graphql } from 'gatsby';
import { login, isAuthenticated } from '../utils/auth';
export default ({ data, transition }) => {
  if (!isAuthenticated()) {
    login();
    return <p>Redirecting to login...</p>;
  }

  return (
    <div style={{ width: '100%' }}>
      <div
        style={transition && transition.style}
        dangerouslySetInnerHTML={{ __html: data.slide.html }}
      />
    </div>
  );
};

export const query = graphql`
  query SlideQuery($index: Int!) {
    slide(index: { eq: $index }) {
      html
      index
    }
  }
`;
